import apiClient from './apiClient';

const chargeableItemService = {
  // POS Menu Items (the chargeable items)
  getAll: (params) => apiClient.get('/pos/api/menu-items/', params),
  getCategories: () => apiClient.get('/pos/api/menu-categories/'),
  // menu is optional — the backend bootstraps the hotel's default
  // Restaurant/Menu chain for fresh hotels.
  createCategory: (data) => apiClient.post('/pos/api/menu-categories/', data),
  createDefaultCategories: () => apiClient.post('/pos/api/menu-categories/create_defaults/'),
  create: (data) => apiClient.post('/pos/api/menu-items/', data),
  update: (id, data) => apiClient.patch(`/pos/api/menu-items/${id}/`, data),
  updatePrice: (id, price) => apiClient.patch(`/pos/api/menu-items/${id}/update_price/`, { price }),
  toggleAvailability: (id) => apiClient.patch(`/pos/api/menu-items/${id}/toggle_availability/`),
  remove: (id) => apiClient.del(`/pos/api/menu-items/${id}/`),
};

export default chargeableItemService;
